import { useEffect } from "react";
import { IMG } from "./images";

export const PHONE_DISPLAY = "(801) 598-1797";
export const PHONE_TEL = "tel:+18015981797";
export const EMAIL = "info@blackskybuilders.com";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { to: "/services", label: "Services", testid: "nav-services-link" },
  { to: "/equitable-construction", label: "Equitable Construction", testid: "nav-equitable-link" },
  { to: "/residential-construction", label: "Residential", testid: "nav-residential-link" },
  { to: "/commercial-construction", label: "Commercial", testid: "nav-commercial-link" },
  { to: "/projects", label: "Projects", testid: "nav-projects-link" },
  { to: "/our-process", label: "Process", testid: "nav-process-link" },
  { to: "/about", label: "About", testid: "nav-about-link" },
  { to: "/financing", label: "Financing", testid: "nav-financing-link" },
];

export const SERVICES = [
  {
    num: "01",
    title: "Home Additions & Expansions",
    desc: "Add bedrooms, bathrooms, offices, or entire living areas with additions planned and built to feel original to your home.",
    img: IMG.addition,
    link: "/residential-construction",
    testid: "service-card-additions",
  },
  {
    num: "02",
    title: "Garages & Garage Apartments",
    desc: "Detached and attached garages, garage build-outs, and finished living space above the garage — planned, permitted, and built to last.",
    img: IMG.concrete,
    link: "/residential-construction",
    testid: "service-card-garages",
  },
  {
    num: "03",
    title: "Mother-in-Law / ADU-Style Spaces",
    desc: "Private, functional living spaces for family, guests, or flexible use — designed around your property and local requirements.",
    img: IMG.renovation,
    link: "/equitable-construction",
    testid: "service-card-adu",
  },
  {
    num: "04",
    title: "Residential Renovations",
    desc: "Strategic renovations that improve how your home functions, flows, and serves the way you actually live.",
    img: IMG.tradesperson,
    link: "/residential-construction",
    testid: "service-card-renovations",
  },
  {
    num: "05",
    title: "Commercial Construction & Improvements",
    desc: "Tenant improvements, build-outs, and property upgrades managed with clear communication and reliable coordination.",
    img: IMG.commercial,
    link: "/commercial-construction",
    testid: "service-card-commercial",
  },
  {
    num: "06",
    title: "Concrete & Exterior Construction",
    desc: "Flatwork, foundations, driveways, and exterior structural work built on proper preparation and a proven process.",
    img: IMG.hero,
    link: "/services",
    testid: "service-card-concrete",
  },
  {
    num: "07",
    title: "Project Management & Construction Solutions",
    desc: "Full-scope project leadership — evaluation, budgeting, coordination, permitting assistance, and construction management through completion.",
    img: IMG.blueprint,
    link: "/our-process",
    testid: "service-card-management",
  },
];

export const PROCESS_STEPS = [
  { n: "01", t: "Consultation", d: "We start with your goals, your property, and what you want the project to accomplish." },
  { n: "02", t: "Project Evaluation", d: "We evaluate the site, existing conditions, and the realities that shape cost and timeline." },
  { n: "03", t: "Scope & Planning", d: "We develop the scope, preliminary budget, and a plan for design, engineering, and scheduling." },
  { n: "04", t: "Financing & Preconstruction", d: "When applicable, we help you explore financing resources while plans and engineering are coordinated." },
  { n: "05", t: "Proposal", d: "You receive a clear proposal outlining scope, budget expectations, and the path forward." },
  { n: "06", t: "Permits & Preparation", d: "We assist with permitting requirements and prepare the site, schedule, and trade coordination." },
  { n: "07", t: "Construction", d: "Our team manages the build — subcontractors, quality control, communication, and accountability." },
  { n: "08", t: "Final Walkthrough", d: "We walk the finished project with you, address the details, and close out the job the right way." },
];

export const WHY_ITEMS = [
  { t: "30+ Years Combined Experience", d: "Decades of combined field and project leadership across residential and commercial construction." },
  { t: "Experienced Project Leadership", d: "Your project is guided by people who have planned, coordinated, and completed real builds." },
  { t: "Network of Proven Trades", d: "An established network of subcontractors and specialty trades we trust on our own jobs." },
  { t: "Clear Communication", d: "Straight answers, honest timelines, and updates you never have to chase." },
  { t: "Detailed Project Planning", d: "Scope, schedule, and sequence worked out before crews ever hit the site." },
  { t: "Budget Awareness", d: "We understand project costs and help you make informed decisions at every step." },
  { t: "Quality Control", d: "Field oversight and standards applied from foundation through finish." },
  { t: "Reliable Coordination", d: "Architects, engineers, inspectors, and trades kept moving in the right order." },
  { t: "Accountability", d: "One accountable team from the initial consultation through the final walkthrough." },
];

export const IDEA_TO_COMPLETION = [
  "Initial project consultation",
  "Property & project evaluation",
  "Preliminary budgeting",
  "Scope development",
  "Financing-resource coordination",
  "Architectural coordination",
  "Engineering coordination",
  "Permitting assistance",
  "Planning & scheduling",
  "Subcontractor & specialty trade coordination",
  "Construction management",
  "Quality control",
  "Final walkthrough & completion",
];

export const EQUITABLE_EXAMPLES = [
  "Expanding existing homes",
  "Building detached or attached garages",
  "Adding living space above garages",
  "Creating mother-in-law or ADU-style spaces",
  "Converting underutilized areas",
  "Adding bedrooms, bathrooms, offices, or recreational areas",
  "Strategic renovations",
  "Improvements that increase functionality and usability",
];

export const SERVICE_AREA_CITIES = [
  "Salt Lake City", "West Valley City", "Sandy", "Draper", "South Jordan", "West Jordan",
  "Murray", "Millcreek", "Holladay", "Cottonwood Heights", "Herriman", "Riverton",
  "Lehi", "Park City", "Bountiful", "Ogden", "Provo",
];

export const MARQUEE_ITEMS = [
  "Salt Lake City", "Home Additions", "Garage Apartments", "ADU-Style Spaces",
  "Renovations", "Concrete", "Commercial Improvements", "Equitable Construction",
  "Project Solutions", "Park City", "Sandy", "Draper", "West Jordan", "South Jordan",
];

export const PROJECT_TYPES = [
  "Home Addition / Expansion",
  "Garage / Garage Apartment",
  "Mother-in-Law / ADU-Style Space",
  "Residential Renovation",
  "Commercial Construction / Improvement",
  "Concrete / Exterior Construction",
  "New Construction",
  "Multi-Family / Family Unit Property",
  "Other / Not Sure Yet",
];

export const BUDGET_RANGES = [
  "Under $25,000",
  "$25,000 – $75,000",
  "$75,000 – $150,000",
  "$150,000 – $300,000",
  "$300,000 – $500,000",
  "$500,000+",
  "Not sure yet",
];

export const START_OPTIONS = [
  "As soon as possible",
  "1–3 months",
  "3–6 months",
  "6–12 months",
  "Flexible / still planning",
];

export const TRI_OPTIONS = ["Yes", "No", "Not Sure"];

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = `${title} | Black Sky Builders`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
}
